export const EMAIL_STATUS = {
  IDLE: 'Idle',
  SENDING: 'Sending',
  SUCCESS: 'Success',
  ERROR: 'Error',
}
